import { render, staticRenderFns } from "./edit-kit.vue?vue&type=template&id=080b6e78"
import script from "./edit-kit.vue?vue&type=script&lang=js"
export * from "./edit-kit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports